import { render, staticRenderFns } from "./LandingNavigation.vue?vue&type=template&id=4b4188d2&scoped=true"
import script from "./LandingNavigation.vue?vue&type=script&lang=js"
export * from "./LandingNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4188d2",
  null
  
)

export default component.exports